module.exports = __webpack_public_path__ + "static/media/1inch.8285e185.svg";